import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LoadingBar from '../../Modules/LoadingBar';
import AlertError from '../../common/AlertError';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import FilterTable from '../../common/FilterTable';

import './Status.less';


class Status extends Component {
  getTableBody = (data) => {
    if (data.length === 0) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {this.props.noDataFoundMessage}
          </div>
        </div>
      );
    }
    if (data.empty) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {data.empty}
          </div>
        </div>
      );
    }
    
    const rows = data.map((item, key) => (
      <tr key={key}>
        <td>{ item.status || '' }</td>
        <td>{ item.date_status_begin || '' }</td>
        <td>{ item.time_in_status || '' }</td>
        <td>{ item.docket_no || '' }</td>
        <td>{ item.status_set_by || '' }</td>
      </tr>
    ));
    return (
      <div>
        <FilterTable premiumSearch={{ uuid: this.props.case_uuid, query: this.props.type }}>
          <table className="sticky-enabled tablesorter">
            <thead>
              <tr>
                <th><span>Status</span></th>
                <th><span>Begin Date</span></th>
                <th><span>Time in Status</span></th>
                <th><span>#</span></th>
                <th><span>Status Set By</span></th>
              </tr>
            </thead>
            <tbody>
              { rows }
            </tbody>
          </table>
        </FilterTable>
      </div>
    );
  };

  render() {
    if (!this.props.dataReady) return <LoadingBar />;
    const alertError = this.props.error ? <AlertError errors={this.props.error} /> : null;

    const tableData = this.props.statuses || [];
    const sortedTableData = tableData.empty ? tableData : _.sortBy(tableData, status => new Date(status.date_status_begin));
    return (
      <div className={this.props.type}>
        {alertError}
        {this.getTableBody(sortedTableData)}
        <UpdateFromPacer
          pacerUpdateHandler={this.props.purchaseData}
          pacerReceipt={this.props.receipt}
          lastUpdated={this.props.lastUpdated} />
      </div>
    );
  }
}

Status.defaultProps = {
  error: null,
  receipt: null,
  type: 'status_pending',
};

Status.propTypes = {
  case_uuid: PropTypes.string.isRequired,
  dataReady: PropTypes.bool.isRequired,
  statuses: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  type: PropTypes.string,
  noDataFoundMessage: PropTypes.string.isRequired,
  error: PropTypes.any,
  purchaseData: PropTypes.func.isRequired,
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/case/status/Status.js